import styled, { css, keyframes } from 'styled-components';

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const skeletonStyles = css`
  animation: ${shimmer} var(--dcm-skeleton-animation-duration) ease-in-out infinite;
  background: linear-gradient(
    90deg,
    var(--dcm-skeleton-shimmer-from) 0px,
    var(--dcm-skeleton-shimmer-to) 40px,
    var(--dcm-skeleton-shimmer-from) 80px
  );
  background-size: 200px 100%;
`;

// Menu Image Banner Placeholder Styles
export const BannerWrapper = styled.div`
  margin: 20px auto 0;
  max-width: var(--dcm-banner-max-width);
  padding: 0 var(--dcm-space-4);

  @media (min-width: 770px) {
    padding: 0;
  }
`;

export const BannerSkeleton = styled.div`
  aspect-ratio: 2.22 / 1;
  background: rgba(0, 0, 0, 0.05);
  border-radius: var(--dcm-banner-border-radius);
  width: 100%;

  @media (min-width: 600px) {
    aspect-ratio: 3 / 1;
  }
`;

// Categories Nav Placeholder Styles
export const CategoriesWrapper = styled.div`
  margin: 32px auto 0;
  max-width: var(--dct--customized-maxSiteWidth);
`;

export const CategoriesWrapperShift = styled.div`
  margin: 0 -16px;
`;

export const CategoriesHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0 var(--dcm-space-4);
  width: 100%;
`;

export const CategoriesHeading = styled.div`
  ${skeletonStyles}
  border-radius: var(--dcm-skeleton-border-radius);
  height: 24px;
  width: 120px;

  @media screen and (min-width: 600px) {
    height: 31px;
    width: 150px;
  }
`;

export const CategoriesSliderContainer = styled.div`
  position: relative;
`;

export const CategoriesViewport = styled.div`
  overflow-x: hidden;
  width: 100%;
`;

export const CategoriesItems = styled.div`
  display: flex;
  gap: var(--dcm-space-3);
  padding: var(--dcm-space-5) var(--dcm-space-4);
`;

export const CategoryCardSkeleton = styled.div`
  ${skeletonStyles}
  border-radius: var(--dcm-skeleton-card-border-radius);
  flex-shrink: 0;
  height: 121px;
  width: 146px;

  @media screen and (min-width: 600px) {
    height: 145px;
    width: 184px;
  }
`;
